import React from 'react';
import { KTSVG } from 'src/_metronic/helpers';

type Props = {
  className?: string;
  color: string;
  icon: string;
  iconColor: string;
  title: string | number;
  description: string;
  isLoading?: boolean;
};

const StatCard: React.FC<Props> = ({ className = '', color, icon, iconColor, title, description, isLoading = false }) => {
  return (
    <div className={`card bg-${color} ${className}`}>
      <div className='card-body'>
        <KTSVG path={icon} className={`svg-icon-${iconColor} svg-icon-3x mb-3`} />

        {isLoading ? (
          <div className='d-flex align-items-center'>
            <span className='spinner-border spinner-border-sm text-white me-2' role='status' />
            <span className='text-white'>Yükleniyor...</span>
          </div>
        ) : (
          <>
            <div className={`text-inverse-${color} fw-bold fs-2x mb-2 mt-2`}>{title}</div>
            <div className={`fw-semibold text-inverse-${color} fs-6`}>{description}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatCard;
